import { cn } from '../../lib/utils'

const shellElevated =
  'overflow-hidden rounded-2xl border border-border bg-card text-card-foreground shadow-[var(--shadow-card)] transition-shadow duration-150 hover:shadow-[var(--shadow-soft)]'

const shellPlain = 'overflow-hidden rounded-2xl border border-border/80 bg-card'

/** `elevated` = standalone surface; `plain` = inside a `Card` (lighter border). */
export function Table({ children, variant = 'elevated', className = '' }) {
  const shell = variant === 'plain' ? shellPlain : shellElevated
  return (
    <div className={cn(shell, className)}>
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse text-left text-sm">{children}</table>
      </div>
    </div>
  )
}

export function TableHeader({ children, className = '' }) {
  return (
    <thead className={cn('border-b border-border bg-muted/50', className)}>{children}</thead>
  )
}

export function TableBody({ children, className = '' }) {
  return <tbody className={cn('divide-y divide-border bg-card', className)}>{children}</tbody>
}

export function TableRow({ children, className = '', ...props }) {
  return (
    <tr className={cn('transition-colors duration-150 hover:bg-muted/40', className)} {...props}>
      {children}
    </tr>
  )
}

const alignClass = (align) => {
  if (align === 'right') return 'text-right'
  if (align === 'center') return 'text-center'
  return 'text-left'
}

export function TableHead({ children, className = '', align = 'left' }) {
  return (
    <th
      scope="col"
      className={cn(
        'px-4 py-3.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground',
        alignClass(align),
        className,
      )}
    >
      {children}
    </th>
  )
}

export function TableCell({ children, className = '', align = 'left' }) {
  return (
    <td className={cn('px-4 py-3.5 text-foreground/90', alignClass(align), className)}>{children}</td>
  )
}
